import React, { lazy, Suspense} from "react";

// import DefaultLoader from "../utilities/loaders/DefaultLoader";

// const NotificationsContent = lazy(() => import('./NotificationsContent'));
import NotificationsContent from './NotificationsContent';

const Notifications = () => {
    return (
        // <Suspense fallback={<DefaultLoader />}>
            <NotificationsContent />
        // {/* </Suspense> */}
    );
};

export default Notifications;